"use client"; // Because you are using hooks and client state
import React, { useState, useEffect } from "react";
import DateTimeDisplay from "../../src/components/dateTimeDisplay/DateTimeDisplay.js";
import { useCountDown } from "../../src/hooks/useCountDown.js";
import OfferStylistCard from "../../src/components/StylistDescriptionCard/OfferStylistCard.js";
import { useDispatch, useSelector } from "react-redux";
import { listCoupon } from "../../src/actions/couponActions.js";
// import couponImage from './offers/coupon.jpg';
import { seoData } from "../../src/fakeData/seoData.js";
import Head from "next/head";
import ChatPopup from "../../src/components/home/ChatPopup.js";
import { usePathname, useSearchParams } from "next/navigation";

const ExpiredNotice = ({ counter }) => {
  return (
    <span className="inline-block mb-2">
      <div className="flex items-center font-semibold text-black">
        <DateTimeDisplay value="00" counter={counter} />
        :
        <DateTimeDisplay value="00" counter={counter} />
        :
        <DateTimeDisplay value="00" counter={counter} />
        :
        <DateTimeDisplay value="00" counter={counter} />
      </div>
    </span>
  );
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <span className="inline-block mb-2">
      <div className="flex items-center font-semibold text-black">
        <DateTimeDisplay value={days} />
        :
        <DateTimeDisplay value={hours} />
        :
        <DateTimeDisplay value={minutes} />
        :
        <DateTimeDisplay value={seconds} />
      </div>
    </span>
  );
};

const ShowCoupon = ({ coupon }) => {
  // Ensure coupons.result is defined and has at least one item
  const targetDate = coupon.endTime ? new Date(coupon.endTime).getTime() : null; // Access the first coupon's endTime if available

  const [days, hours, minutes, seconds] = useCountDown(targetDate); // Pass the targetDate to the countdown hook
  const counter = days + hours + minutes + seconds; // Calculate the total countdown

  const [message, setMessage] = useState(null);
  const handleClipboardCopy = (value) => {
    navigator.clipboard.writeText(value);
    setMessage("Copied !!");
    setTimeout(() => setMessage(null), 2000);
  };

  return (
    <>
      <div
        className="block md:flex lg:flex md:justify-between lg:justify-between itemms-center bg-white rounded-md shadow-sm"
        style={{ border: "2px solid #BD2777" }}
      >
        <div className="p-6 flex items-center justify-items-start">
          <figure>
            <span
              style={{
                boxSizing: " border-box",
                display: "inline-block",
                overflow: "hidden",
                width: "initial",
                height: "initial",
                background: "none",
                opacity: "1",
                border: " 0px",
                margin: "0px",
                padding: "0px",
                position: "relative",
                maxWidth: "100%",
              }}
            >
              <span
                style={{
                  boxSizing: "border-box",
                  display: "block",
                  width: "initial",
                  height: "initial",
                  background: "none",
                  opacity: "1",
                  border: "0px",
                  margin: "0px",
                  padding: "0px",
                  maxWidth: "100%",
                }}
              >
                <img
                  alt=""
                  aria-hidden="true"
                  src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27100%27%20height=%27100%27/%3e"
                  style={{
                    display: "block",
                    maxWidth: "100%",
                    width: "initial",
                    height: "initial",
                    background: "none",
                    opacity: "1",
                    border: "0px",
                    margin: "0px",
                    padding: "0px",
                  }}
                />
              </span>
              <img
                srcSet={`/assets/offers/coupon.jpg 456w, /assets/offers/coupon.jpg 456w`}
                src={`/assets/offers/coupon.jpg`}
                alt={coupon.title}
                decoding="async"
                data-nimg="intrinsic"
                className="rounded-lg"
                style={{
                  marginLeft: "-60px",
                  position: "absolute",
                  inset: "0px",
                  boxSizing: "border-box",
                  padding: "0px",
                  border: "none",
                  margin: "auto",
                  display: "block",
                  width: "140%", // Use 100% width to make the image responsive
                  height: "auto", // Set height to auto to maintain aspect ratio
                  minWidth: "140%", // Ensures the image takes up the full width of the container
                  maxWidth: "140%", // Limits the image width to the container's width
                  minHeight: "auto", // Adjust minimum height as needed
                  maxHeight: "140%", // Ensures the image doesn't overflow
                }}
              />
            </span>
          </figure>

          <div className="ml-5">
            {counter <= 0 ? (
              <ExpiredNotice counter={counter} />
            ) : (
              <ShowCounter
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
              />
            )}
<h2 style={{ fontSize: "22px", lineHeight: "16px" }} className="font-medium mb-3">
  {coupon.title}
</h2>            <p className=" font-bold text-xl text-gray-600">
              <span className="text-lg md:text-xl lg:text-2xl leading-12 text-red-500 font-extrabold">
                {coupon.discountPercentage}%
              </span>{" "}
              Off
            </p>
          </div>
        </div>
        <div
          className="md:border-l-2 lg:border-l-2 border-dashed lg:w-1/3 md:w-1/3 relative px-6"
          style={{ borderLeft: "2px dashed #BD2777" }}
        >
          <div
            className=" flex lg:my-6 md:my-5 mb-6 items-center 
                md:before:-top-[10px] md:before:-left-[13px] md:before:absolute md:before:w-[25px] md:before:h-[25px] md:before:bg-[#fafafa] md:before:rounded-[100%] 
                md:after:-bottom-[10px] md:after:-left-[13px] md:after:absolute md:after:w-[25px] md:after:h-[25px] md:after:bg-[#fafafa] md:after:rounded-[100%]"
          >
            <div className="w-full">
              <div className="block">
                <div className=" font-medium flex items-center mb-1">
                  <span className="text-black">Coupon</span>
                  <div className="ml-2">
                    {counter <= 0 ? (
                      <span className="text-red-600 inline-block">Inactive</span>
                    ) : (
                      <span className="text-pink-600 inline-block">Active</span>
                    )}
                  </div>
                </div>
                <div className=" border border-dashed bg-emerald-50 py-2 border-emerald-300 rounded-lg text-center block">
                  <button
                    onClick={() => handleClipboardCopy(coupon.couponCode)}
                    className="block w-full"
                  >
                    <span className="uppercase font-semibold text-base leading-7 text-pink-600">
                      {message || coupon.couponCode}
                    </span>
                  </button>
                </div>
              </div>

              <p className="text-xs leading-5 text-gray-500 mt-2">
                * This coupon code will apply on{" "}
                <span className="font-bold text-gray-700">
                  {coupon.productType} type products
                </span>{" "}
                and when you shopping more then{" "}
                <span className="font-bold text-gray-700">₹{coupon.minimumAmount}</span>{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Offers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const targetDate = new Date().getTime() + 2 * 24 * 60 * 60 * 1000;
  const dispatch = useDispatch();

  const couponList = useSelector((state) => state.couponList);
  const { error, loading, coupons } = couponList;
  useEffect(() => {
    dispatch(listCoupon());
  }, [dispatch]);

  const [showScrollButton, setShowScrollButton] = useState(false);

  // Effect for scrolling behavior
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const { title, description, keywords, author } = seoData.offers;

  const pathname = usePathname();
  const searchParams = useSearchParams();
  const canonicalUrl = `https://www.doortodoorbeauty.com${pathname}${
    searchParams.toString() ? `?${searchParams.toString()}` : ""
  }`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <div className="flex justify-center py-10 lg:py-20 bg-indigo-100 w-full bg-cover bg-no-repeat bg-bottom" 
            style={{ backgroundImage: `url('/assets/Blog/BlogHeader.jpg')` }}>
            <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
                <div className="w-full flex justify-center flex-col relative">
                    <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-serif text-center text-pink-600" style={{color: '#DB2777'}}>Mega Offer</h1>
                </div>
            </div>
        </div>
        <ChatPopup />
      <div className="w-full">
        <div className="px-4 sm:px-10 py-10 lg:py-20">
          <div className="grid gap-6 grid-cols-1 xl:grid-cols-2">
            {!!coupons?.result &&
              coupons.result.map((item, index) => (
                <ShowCoupon coupon={item} key={index} />
              ))}
          </div>
          {/* <br /><br />
          <OfferStylistCard /> */}
        </div>

        {showScrollButton && (
          <button
            className="fixed bottom-[100px] right-8 bg-pink-600 hover:bg-emerald-600 text-white p-3 rounded-full shadow-lg"
            onClick={scrollToTop}
          >
            ⬆️
          </button>
        )}
      </div>
    </>
  );
};

export default Offers;
